import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DashboardStats from "../../../common/Dashboard/DashboardStats";
import RefreshButtonTable from "../../../common/RefreshButtonTable";
import StudentTable from "../../Organisation/School/StudentTable";
import { useGetStudentReport } from "../../../../hooks/school/student/useGetStudentReport";
import ReportSkeleton from "./ReportSkeleton";
import "../../../../common/styles/table.css";

/**
 * StudentReport - Displays student report list with stats and table
 */
const StudentReport = () => {
    const navigate = useNavigate();

    const { loading, error, reportData, getStudentReport } =
        useGetStudentReport();

    // Fetch student report on mount
    useEffect(() => {
        getStudentReport(1);
    }, []);

    const handleRefresh = () => {
        getStudentReport(1);
    };

    /**
     * Generate student stats from API data
     */
    const getStudentStats = () => {
        return [
            {
                label: "Avg. Overall Progress",
                value: `${reportData?.avg_overall_progress || 0}%`,
                icon: "fa-user",
                colorClass: "dashboard-stat-card-purple",
            },
            {
                label: "Avg. Quiz Score",
                value: reportData?.avg_quiz_score || 0,
                icon: "fa-file-arrow-down",
                colorClass: "dashboard-stat-card-green",
            },
            {
                label: "Total Quests Assigned",
                value: reportData?.total_quests_assigned || 0,
                icon: "fa-file-arrow-down",
                colorClass: "dashboard-stat-card-peach",
            },
        ];
    };

    /**
     * Handle student row click - navigate to detail page
     */
    const handleStudentClick = (student) => {
        navigate(`/school-admin/school/report/students/${student.id}`);
    };

    // Show skeleton on initial load
    if (loading && reportData === undefined) {
        return (
            <>
                <div className="pt-2">
                    <RefreshButtonTable handleRefresh={handleRefresh} loading={loading} />
                </div>
                <ReportSkeleton />
            </>
        );
    }

    return (
        <>
            <div className="pt-2">
                <RefreshButtonTable handleRefresh={handleRefresh} loading={loading} />
            </div>

            <DashboardStats stats={getStudentStats()} />

            <StudentTable onStudentClick={handleStudentClick} />
        </>
    );
};

export default StudentReport;
